/*
  Ivy Pillow — lookbook-hotspots met productpaneel rechts: één paneel
  tegelijk open, wisselen tussen stippen gaat direct, sluiten met Escape,
  het kruisje, nogmaals de stip of een klik buiten de sectie.
  Panelen zijn inert zolang ze dicht zijn (§13.7).
*/
(() => {
  function initIvyLookbook(scope) {
    const bereik = scope && scope.querySelectorAll ? scope : document;
    bereik.querySelectorAll('.ivy-lookbook').forEach((sectie) => {
      if (sectie.dataset.ivyInit === 'true') return;
      sectie.dataset.ivyInit = 'true';

      const spots = Array.from(sectie.querySelectorAll('.ivy-lookbook__spot'));
      const panelen = Array.from(sectie.querySelectorAll('.ivy-lookbook__paneel'));
      if (!spots.length || !panelen.length) return;

      const paneelVan = (spot) =>
        panelen.find((paneel) => paneel.dataset.paneel === spot.dataset.spot);

      const zetOpen = (spot, open) => {
        const stip = spot.querySelector('.ivy-lookbook__stip');
        const paneel = paneelVan(spot);
        spot.classList.toggle('ivy-lookbook__spot--open', open);
        if (stip) stip.setAttribute('aria-expanded', String(open));
        if (paneel) {
          paneel.classList.toggle('ivy-lookbook__paneel--open', open);
          paneel.toggleAttribute('inert', !open);
        }
      };

      const sluitAlles = (behalve) => {
        spots.forEach((spot) => {
          if (spot !== behalve) zetOpen(spot, false);
        });
      };

      spots.forEach((spot) => {
        const stip = spot.querySelector('.ivy-lookbook__stip');
        if (!stip) return;
        stip.addEventListener('click', (e) => {
          e.stopPropagation();
          const open = !spot.classList.contains('ivy-lookbook__spot--open');
          sluitAlles(spot);
          zetOpen(spot, open);
        });
      });

      panelen.forEach((paneel) => {
        const sluit = paneel.querySelector('.ivy-lookbook__sluit');
        if (!sluit) return;
        sluit.addEventListener('click', () => {
          const spot = spots.find((sp) => sp.dataset.spot === paneel.dataset.paneel);
          sluitAlles();
          if (spot) {
            const stip = spot.querySelector('.ivy-lookbook__stip');
            if (stip) stip.focus();
          }
        });
      });

      document.addEventListener('click', (e) => {
        if (!sectie.contains(e.target)) sluitAlles();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const open = sectie.querySelector('.ivy-lookbook__spot--open');
        if (!open) return;
        sluitAlles();
        const stip = open.querySelector('.ivy-lookbook__stip');
        if (stip) stip.focus();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initIvyLookbook(document));
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => initIvyLookbook(e.target));
  }
})();
